/**
 * Cart Drawer Featured Collection - JavaScript
 * Gère l'ajout au panier depuis les recommandations
 */

class CartDrawerFeaturedCollection {
  constructor() {
    this.initEventListeners();
  }

  initEventListeners() {
    // Écouter les soumissions de formulaire d'ajout au panier
    document.addEventListener('submit', (e) => {
      if (e.target.matches('.cart-drawer__add-form')) {
        e.preventDefault();
        this.handleAddToCart(e.target);
      }
    });
  }

  // Plus besoin d'initSlider car nous utilisons le système standard
  initSliderOLD() {
    const slider = document.querySelector('[data-slider="cart-drawer"]');
    if (!slider) return;

    const prevBtn = document.querySelector('.cart-drawer__arrow--prev');
    const nextBtn = document.querySelector('.cart-drawer__arrow--next');
    
    if (!prevBtn || !nextBtn) return;

    let currentIndex = 0;
    const getSlideWidth = () => this.getSlideWidth();
    const getVisibleSlides = () => this.getVisibleSlides();
    const totalSlides = slider.children.length;

    const updateButtons = () => {
      const visibleSlides = getVisibleSlides();
      const maxIndex = Math.max(0, totalSlides - visibleSlides);
      prevBtn.disabled = currentIndex <= 0;
      nextBtn.disabled = currentIndex >= maxIndex;
    };

    const updateSlider = () => {
      const slideWidth = getSlideWidth();
      const translateX = -currentIndex * slideWidth;
      slider.style.transform = `translateX(${translateX}px)`;
      updateButtons();
    };

    prevBtn.addEventListener('click', () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateSlider();
      }
    });

    nextBtn.addEventListener('click', () => {
      const visibleSlides = getVisibleSlides();
      const maxIndex = Math.max(0, totalSlides - visibleSlides);
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateSlider();
      }
    });

    // Initialiser l'état des boutons
    updateButtons();
    
    // Touch/swipe support
    this.addTouchSupport(slider, () => {
      if (currentIndex > 0) {
        currentIndex--;
        updateSlider();
      }
    }, () => {
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateSlider();
      }
    });

    // Réinitialiser lors du redimensionnement
    window.addEventListener('resize', () => {
      const newVisibleSlides = getVisibleSlides();
      const newMaxIndex = Math.max(0, totalSlides - newVisibleSlides);
      if (currentIndex > newMaxIndex) {
        currentIndex = newMaxIndex;
      }
      updateSlider();
    });
  }

  getVisibleSlides() {
    const container = document.querySelector('.cart-drawer__slider-container');
    if (!container) return 1;
    
    const containerWidth = container.offsetWidth - 40; // padding
    const slideWidth = this.getSlideWidth();
    return Math.max(1, Math.floor(containerWidth / slideWidth));
  }

  getSlideWidth() {
    // Retourne la largeur de slide + gap en fonction de l'écran
    if (window.innerWidth <= 480) {
      return 152; // 140px + 12px gap
    } else if (window.innerWidth <= 768) {
      return 172; // 160px + 12px gap  
    }
    return 192; // 180px + 12px gap
  }

  addTouchSupport(element, onSwipeLeft, onSwipeRight) {
    let startX = 0;
    let startY = 0;
    
    element.addEventListener('touchstart', (e) => {
      const touch = e.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
    }, { passive: true });
    
    element.addEventListener('touchend', (e) => {
      const touch = e.changedTouches[0];
      const distX = touch.clientX - startX;
      const distY = touch.clientY - startY;
      
      if (Math.abs(distX) > Math.abs(distY) && Math.abs(distX) > 50) {
        e.preventDefault();
        if (distX > 0) {
          onSwipeLeft();
        } else {
          onSwipeRight();
        }
      }
    });
  }

  async handleAddToCart(form) {
    const button = form.querySelector('.cart-drawer__add-btn');
    const variantId = form.querySelector('input[name="id"]').value;
    
    // État de chargement
    button.classList.add('loading');
    button.disabled = true;
    
    try {
      // Ajout au panier via Fetch API
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      if (response.ok) {
        // Succès - Actualiser le panier
        this.updateCartDrawer();
        this.showSuccessFeedback(button);
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      this.showErrorFeedback(button);
    } finally {
      // Retirer l'état de chargement
      setTimeout(() => {
        button.classList.remove('loading');
        button.disabled = false;
      }, 1000);
    }
  }

  async updateCartDrawer() {
    try {
      // Récupérer le HTML mis à jour du panier
      const response = await fetch('/?section_id=cart-drawer');
      const html = await response.text();
      
      // Parser et remplacer le contenu
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newCartDrawer = doc.querySelector('cart-drawer');
      
      if (newCartDrawer) {
        const currentCartDrawer = document.querySelector('cart-drawer');
        if (currentCartDrawer) {
          // Préserver l'état ouvert/fermé
          const wasOpen = currentCartDrawer.classList.contains('active');
          currentCartDrawer.replaceWith(newCartDrawer);
          
          if (wasOpen) {
            newCartDrawer.classList.add('active');
          }
        }
      }

      // Déclencher l'événement de mise à jour du panier
      document.dispatchEvent(new CustomEvent('cart:updated'));
      
    } catch (error) {
      console.error('Error updating cart drawer:', error);
      // Fallback : recharger la page
      window.location.reload();
    }
  }

  showSuccessFeedback(button) {
    const originalText = button.textContent;
    button.textContent = '✓ Added!';
    button.style.background = '#4caf50';
    
    setTimeout(() => {
      button.textContent = originalText;
      button.style.background = '';
    }, 2000);
  }

  showErrorFeedback(button) {
    const originalText = button.textContent;
    button.textContent = 'Error';
    button.style.background = '#f44336';
    
    setTimeout(() => {
      button.textContent = originalText;
      button.style.background = '';
    }, 2000);
  }
}

// Initialiser quand le DOM est prêt
document.addEventListener('DOMContentLoaded', () => {
  new CartDrawerFeaturedCollection();
});

// Export pour utilisation dans d'autres scripts
window.CartDrawerFeaturedCollection = CartDrawerFeaturedCollection;